import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Typography,
  Divider
} from '@mui/material';
import { NavLink } from 'react-router-dom';

// Icons
import DashboardIcon from '@mui/icons-material/Dashboard';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import PaymentsIcon from '@mui/icons-material/Payments';
import BuildIcon from '@mui/icons-material/Build';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import ArticleIcon from '@mui/icons-material/Article';
import ReviewsIcon from '@mui/icons-material/Reviews';
import UsersIcon from '@mui/icons-material/VerifiedUserSharp';

const drawerWidth = 260;

const menu = [
  { text: 'Dashboard', path: '/', icon: <DashboardIcon /> },
  { text: 'Vehicle Remap Leads', path: '/leads', icon: <DirectionsCarIcon /> },
  { text: 'Orders & Payments', path: '/orders', icon: <PaymentsIcon /> },
  { text: 'Services', path: '/services', icon: <BuildIcon /> },
  { text: 'Pricing Plans', path: '/plans', icon: <PriceChangeIcon /> },
  { text: 'FAQs', path: '/faqs', icon: <QuestionAnswerIcon /> },
  { text: 'Blogs', path: '/blogs', icon: <ArticleIcon /> },
  { text: 'Testimonials', path: '/testimonials', icon: <ReviewsIcon /> },
  { text: 'Users', path: '/users', icon: <UsersIcon /> },
];

export default function Sidebar() {
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          background: 'linear-gradient(180deg, #0f2027, #203a43)',
          color: '#fff',
          borderRight: 'none',
        },
      }}
    >
      {/* Brand Header */}
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" fontWeight="bold">
          Custom Remaps
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.7 }}>
          Admin Panel
        </Typography>
      </Box>

      <Divider sx={{ borderColor: 'rgba(255,255,255,0.15)' }} />

      {/* Menu */}
      <List sx={{ mt: 1 }}>
        {menu.map(({ text, path, icon }) => (
          <ListItemButton
            key={text}
            component={NavLink}
            to={path}
            sx={{
              mx: 1,
              my: 0.5,
              borderRadius: 2,
              color: 'rgba(255,255,255,0.85)',
              '& .MuiListItemIcon-root': {
                color: 'inherit',
                minWidth: 40,
              },
              '&.active': {
                background: 'rgba(255,255,255,0.12)',
                color: '#fff',
                fontWeight: 'bold',
              },
              '&:hover': {
                background: 'rgba(255,255,255,0.08)',
              },
            }}
          >
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText primary={text} />
          </ListItemButton>
        ))}
      </List>

      {/* Footer */}
      <Box sx={{ mt: 'auto', p: 2, opacity: 0.6 }}>
        <Typography variant="caption">
          © {new Date().getFullYear()} Custom Remaps
        </Typography>
      </Box>
    </Drawer>
  );
}
